import React from 'react';
export function OfferIntro() {
  return <section className="py-20 bg-cream-light" data-id="element-126">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-127">
        <div className="inline-block mb-6" data-id="element-128">
          <span className="block w-12 h-1 bg-sage-dark mx-auto rounded-full mb-6" data-id="element-129"></span>
          <h2 className="text-3xl md:text-5xl font-bold text-ink" data-id="element-130">
            Introducing the <br className="hidden sm:block" data-id="element-131" />
            <span className="text-sage-dark" data-id="element-132">14-Day Belly Reset Plan.</span>
          </h2>
        </div>

        <p className="text-xl md:text-2xl text-ink/80 leading-relaxed mt-6 font-serif italic" data-id="element-133">
          A plan designed specifically for men and women over 40 who want to
          feel lighter, reduce inflammation, and notice their clothes fitting
          more comfortably in just 14 days.
        </p>
      </div>
    </section>;
}